<script setup lang="ts">
import { inject, type HTMLAttributes } from 'vue';
import { tabsInjectionKey } from './internal';
import NxTab from './NxTab.vue';

defineProps</* @vue-ignore */ HTMLAttributes>();

const tabsInjection = inject(tabsInjectionKey);
</script>
<template>
  <div
    v-if="tabsInjection && tabsInjection.tabs.value.size > 0"
    role="tablist"
    :class="{
      'is-compact': tabsInjection.compact.value,
      'is-wrapped': tabsInjection.wrap.value,
      'is-sticky': tabsInjection.sticky.value,
      'is-on-page': tabsInjection.stickyBackground.value === 'page',
    }"
  >
    <NxTab
      v-for="[tabId, entry] of tabsInjection.tabs.value"
      :key="`tab_${tabId}`"
      :tab-id="tabId"
      :tab-label="entry.label"
      :tab-count="entry.count"
    />
  </div>
</template>
<style scoped>
[role='tablist'] {
  display: flex;
  flex: 0 0 auto;
  min-width: 0;
  box-shadow: inset 0 calc(var(--nxt-hairline) * -1) 0 var(--nxt-border);
}

/* Long content in a scrolling container: the tab row stays reachable. */
[role='tablist'].is-sticky {
  position: sticky;
  inset-block-start: 0;
  z-index: 1;
  background: var(--nxt-surface-bg);
}

/* Tabs placed on the page background: the sticky row paints that, not a surface. */
[role='tablist'].is-sticky.is-on-page {
  background: var(--nxt-bg-app);
}

/* Narrow panes: one line, scrolled sideways instead of squeezed. */
[role='tablist'].is-compact {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
}

[role='tablist'].is-wrapped {
  flex-wrap: wrap;
  overflow: visible;
}
</style>
